<template>
  <div class="view-list-container" :class="{ 'border': isShowBorder }" :style="{ height, minHeight: '320px' }">
    <el-scrollbar
      wrap-style="overflow-x:hidden;"
      :style="{ height: '100%' }"
    >
      <div v-if="value.length">
        <div v-for="(item, index) in value" :key="index" class="view-list-item">
          <el-tooltip effect="dark" :content="viewKey ? item[viewKey] : item" placement="top-start">
            <div class="truncate flex-1">
              {{ viewKey ? item[viewKey] : item }}
            </div>
          </el-tooltip>
          <div class="flex-grow-0 title-action">
            <i class="el-icon-delete font-16" @click="onDel(index)" />
          </div>
        </div>
      </div>
      <el-empty v-else v-bind="empty_config.props" />
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  props: {
    /** 列表值 */
    value: {
      type: Array,
      default: () => [],
    },
    /** 展示键 */
    viewKey: {
      type: [String, null],
      default: null,
    },
    /** 容器高度 */
    height: {
      type: String,
      default: '320px',
    },
    /** 是否显示边框 */
    isShowBorder: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      /** 空数据配置 */
      empty_config: {
        props: {
          description: '暂无配置',
        },
      },
    };
  },
  methods: {
    /**
     * 删除
     * @param {number} index 数据项下标
     * @returns {void}
     */
    onDel(index) {
      this.value.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.view-list-container {
  &.border {
    border: 1px solid #ebeef5;
  }
  .view-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #ebeef5;
    transition: background-color 0.25s ease;
    padding: 16px 20px;
    cursor: pointer;
    &:hover {
      background-color: #f5f7fa;
    }
    i {
      cursor: pointer;
      &:hover {
        color: #F56C6C;
      }
    }
  }
}
</style>
